import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShopHomePage from './pages/ShopHomePage';
import CheckoutPage from './pages/CheckoutPage';
import OrderSuccess from './pages/OrderSuccess';
import TemplatedMenuPage from './pages/TemplatedMenuPage';
import ShopByIdPage from './pages/ShopByIdPage';
import ShopTemplatedWrapper from './pages/ShopTemplatedWrapper';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Switch>
        <Route exact path="/restaurant/:restaurantId/:restaurantName?" component={TemplatedMenuPage} />
        <Route exact path="/shop/:shopId" component={ShopByIdPage} />
        
        {/* Slugged routes */}
        <Route exact path="/:shopSlug/:shopCode" component={ShopTemplatedWrapper} />
        <Route path="/:shopSlug/:shopCode/checkout" component={CheckoutPage} />
        <Route path="/:shopSlug/:shopCode/order-success/:orderId" component={OrderSuccess} />

        {/* Backwards compatibility fallback routes */}
        <Route exact path="/:shopCode" component={ShopTemplatedWrapper} />
        <Route path="/:shopCode/checkout" component={CheckoutPage} />
        <Route path="/:shopCode/order-success/:orderId" component={OrderSuccess} />
      </Switch>
    </Router>
    
  );
}

export default App;
